import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { MapPin, Star } from 'lucide-react';

const About = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section
      id="about"
      ref={ref}
      className="py-24 md:py-32 bg-[#1a2e23] noise-overlay"
      data-testid="about-section"
    >
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-24 items-center">
          {/* Image side */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, ease: 'easeOut' }}
            className="relative order-2 lg:order-1"
          >
            <div className="relative overflow-hidden rounded-sm">
              <img
                src="/images/about_interior.jpg"
                alt="Polje Coffee Co interior"
                className="w-full h-[400px] lg:h-[600px] object-cover img-hover"
                data-testid="about-image"
              />
              {/* Overlay badge */}
              <div className="absolute bottom-6 left-6 glass px-6 py-4 rounded-sm">
                <div className="flex items-center gap-2 mb-2">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-[#d4a84b] text-[#d4a84b]" />
                  ))}
                </div>
                <p className="text-[#f5f0e1] font-semibold">15 Mutlu Müşteri</p>
              </div>
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -right-6 w-48 h-48 border border-[#d4a84b]/20 rounded-sm -z-10" />
          </motion.div>

          {/* Text side */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, ease: 'easeOut', delay: 0.2 }}
            className="order-1 lg:order-2"
          >
            <span className="font-accent text-[#d4a84b] text-2xl" data-testid="about-label">
              Hikayemiz
            </span>

            <h2 className="font-['Playfair_Display'] text-4xl md:text-5xl lg:text-6xl font-bold text-[#f5f0e1] mt-4 mb-8" data-testid="about-title">
              Kahveye Olan <br />
              <span className="text-[#d4a84b]">Tutkumuz</span>
            </h2>

            <div className="space-y-6 text-[#b8c4b8] text-lg leading-relaxed" data-testid="about-content">
              <p>
                Polje Coffee Co olarak, kahvenin sadece bir içecek değil, bir yaşam tarzı olduğuna inanıyoruz.
                Dünyanın en seçkin kahve çekirdeklerini özenle kavuruyor ve her fincanda mükemmelliği sunuyoruz.
              </p>
              <p>
                Ayrancı'nın kalbinde, sıcak ve samimi atmosferimizde kahve tutkunlarını ağırlamaktan
                mutluluk duyuyoruz. Her bir bardak, bizim için bir sanat eseridir.
              </p>
              <p>
                Uzman baristalarımız, geleneksel yöntemlerle modern teknikleri harmanlayarak
                size unutulmaz bir kahve deneyimi yaşatmak için burada.
              </p>
            </div>

            {/* Location info */}
            <div className="mt-10 flex items-start gap-4 p-6 bg-[#2d4a3e] rounded-sm" data-testid="about-location">
              <MapPin className="w-6 h-6 text-[#d4a84b] flex-shrink-0 mt-1" />
              <div>
                <p className="text-[#f5f0e1] font-semibold mb-1">Konumumuz</p>
                <p className="text-[#b8c4b8]">
                  Ayrancı, Hoşdere Cd. No:116 D:C<br />
                  06540 Çankaya / Ankara
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
